import { ICuttingBaseMaterial, TextureSettings } from './cutting-base-material.model';

export class CuttingButt implements ICuttingBaseMaterial {
  id: number;
  groupId: number;
  name: string;
  article: string;
  sign: string;
  thickness: number;
  overhang: number;
  textureName: string;
  textureRotationDegree: number;
  color: string;
  allowance: number;
  width: number;
  isTape: boolean;
  measureName: string;
  price: number;
  weightPerItem: number;
  textureLink: string;
  cropTextureLink: string;
  quantityInStock: number;
  textureSettings?: TextureSettings;

  constructor(butt?: CuttingButt | any) {
    butt = butt || {};
    this.id = butt.id || 0;
    this.groupId = butt.groupId || 0;
    this.name = butt.name || '';
    this.article = butt.article || '';
    this.sign = butt.sign || '';
    this.textureName = butt.textureName || '';
    this.color = butt.color || '';
    this.thickness = butt.thickness || 0;
    this.overhang = butt.overhang || 0;
    this.allowance = butt.allowance || 0;
    this.isTape = butt.isTape || false;
    this.measureName = butt.measureName || '';
    this.price = butt.price || 0;
    this.weightPerItem = butt.weightPerItem || 0;
    this.textureLink = butt.textureLink || '';
    this.cropTextureLink = butt.cropTextureLink || '';
    this.quantityInStock = butt.quantityInStock || 0;
  }
}
